import { useEffect, useState } from "react";

/** يمنع إرسال طلب مع كل حرف — يُستخدم في كل حقول البحث. */
export const useDebounced = (value, delay = 350) => {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
};

export const errText = (e, fallback = "تعذّر تنفيذ الطلب") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
};
